// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieBar_container__3FL0j","text":"CookieBar_text__2UaM3","buttonContainer":"CookieBar_buttonContainer__FN3i3"};